/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Model_Row2_SkillInputs */

const en_mk_model_row2_skill = /** @type {(inputs: Mk_Model_Row2_SkillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write captions & content calendar`)
};

const id_mk_model_row2_skill = /** @type {(inputs: Mk_Model_Row2_SkillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tulis caption & kalender konten`)
};

/**
* | output |
* | --- |
* | "Write captions & content calendar" |
*
* @param {Mk_Model_Row2_SkillInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_model_row2_skill = /** @type {((inputs?: Mk_Model_Row2_SkillInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Model_Row2_SkillInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_model_row2_skill(inputs)
	return en_mk_model_row2_skill(inputs)
});